import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "column field" };
const _hoisted_2 = {
    key: 0,
    class: "label"
};
import { onMounted, ref } from "vue";
import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css'; // import the styles somewhere
// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from "prismjs/components/prism-core";
import 'prismjs/components/prism-json';
import 'prismjs/themes/prism-dark.css'; // import syntax highlighting styles
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormCodeEditorField',
    props: {
        modelValue: {},
        language: {},
        label: {},
        validator: { type: Function },
        validationId: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { emit: __emit }) {
        const code = ref("");
        const props = __props;
        // Event for two-way binding
        const emit = __emit;
        const onInput = () => {
            emit('update:modelValue', code.value);
        };
        const highlighter = (code) => {
            return highlight(code, languages[props.language]);
        };
        onMounted(() => {
            code.value = props.modelValue || "";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.label)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
                    : _createCommentVNode("", true),
                _createVNode(_unref(PrismEditor), {
                    class: _normalizeClass(["codeEditor", { 'is-danger': _ctx.validator ? !_ctx.validator(_ctx.validationId ? _ctx.validationId : this, _ctx.modelValue) : false }]),
                    modelValue: code.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((code).value = $event)),
                    highlight: highlighter,
                    "line-numbers": "",
                    onInput: _cache[1] || (_cache[1] = ($event) => (onInput()))
                }, null, 8, ["modelValue", "class"]),
                _renderSlot(_ctx.$slots, "default")
            ]));
        };
    }
});
